import React from 'react';
import Spinner, { SpinnerSize } from '../../../spinner/Spinner';
export const AutoCompleteV2LoadingIndicator = () => /*#__PURE__*/React.createElement(Spinner, {
  size: SpinnerSize.SMALLER,
  color: "neutrals.medium"
});
export default AutoCompleteV2LoadingIndicator;
//# sourceMappingURL=AutoCompleteV2LoadingIndicator.js.map